import _ from 'lodash';

export const calculateColumnOrder = (availableKeys: string[] = [], keyOrder: string[] = []) => {
    const intersectionDefaultOrdered = _.intersection(availableKeys, keyOrder);
    const intersectionCustomOrdered = _.intersection(keyOrder, availableKeys);
    return _.isEqual(intersectionDefaultOrdered, intersectionCustomOrdered)
        ? availableKeys
        : _.union(intersectionCustomOrdered, availableKeys);
};
